import { useSystemAssets } from '@bz/systemAssets';
import { JSXElement } from 'solid-js';

function Empty(props: { children?: JSXElement; class?: string; imgName?: string }) {
  const [assets] = useSystemAssets();
  return (
    <div class={cx('text-center py-12 bg-layer4 flex flex-col items-center', props.class)}>
      <img class="size-[7.5rem]" src={assets[props.imgName || 'generalemptyEmptyimg']} />
      <div class="text-xs font-semibold my-4 text-neutral-main2">{props.children || t('Nothing Here Yet')}</div>
    </div>
  );
}

export default Empty;
